import useLocalStorage from 'app/hooks/useLocalStorage'
import Basket from 'components/Basket/Basket'
import { BASKET_TYPES } from 'components/Basket/constants'
import ButtonCinestar from 'components/Buttons/ButtonCinestar/ButtonCinestar'
import FormCustomBenefitPayment from 'components/Forms/FormCustomBenefitPayment/FormCustomBenefitPayment'
import GoodsWidthAmount from 'components/Goods/GoodsWidthAmount'
import OrderStepCircle from 'components/OrderStepsHeader/components/OrderStepCircle/OrderStepCircle'
import InfoWindow from 'components/Windows/InfoWindow/InfoWindow'
import { cinemaSlugToId } from 'global/helpers/cinemaList'
import PaymentMethod from 'pages/OrderSummary/components/PaymentMethod/PaymentMethod'
import { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router'
import gtmAddGiftVoucher from 'services/gtm/gtmAddGiftVoucher'
import gtmRemoveGiftVoucher from 'services/gtm/gtmRemoveGiftVoucher'
import AddVoucher from './components/AddVoucher'
import EmptyBasket from './components/EmptyBasket'
import ContactInfo from './components/contactInfo/ContactInfo'
import hocBuyTicketVoucher from './hocBuyTicketVoucher'

function BuyTicketVoucher({
    paymentStart,
    isAuthorized,
    setPayment,
    basket,
    userAuthInfo,
    push,
    postMealVoucher,
    setGoPayVariant,
    goPayVariant,
    initGiftVoucherBasket,
}) {
    const { search } = useLocation()
    const intl = useIntl()

    const params = new URLSearchParams(search)
    const paramsObject = Object.fromEntries(params)

    const referer = paramsObject?.ref
    const voucherid = paramsObject.voucherid

    const [userInfo, setUserInfo] = useLocalStorage('user-info', null)

    useEffect(() => {
        localStorage.setItem('referer', paramsObject.ref)
        const cinemaId = cinemaSlugToId(paramsObject.site)
        if (cinemaId !== undefined) {
            localStorage.setItem('site', paramsObject.site)
            localStorage.setItem('cinemaid', cinemaId)
        }
        if (voucherid) initGiftVoucherBasket(voucherid)
    }, [])

    const setVoucher = (newAmount, voucherid) => {
        const cinemaid = cinemaSlugToId(paramsObject.site) ?? localStorage.getItem('cinemaid')
        postMealVoucher({ cinemaid, vouchers: [{ voucherid, amount: newAmount }] })
    }

    return (
        <Container fluid className={'order-summary-page d-flex flex-column'}>
            {/* header part */}
            <div className="d-flex">
                <div className="w-25 my-5">
                    <ButtonCinestar
                        variant={'secondary'}
                        iconLeft={'arrow-left'}
                        className={'order-steps-header--button'}
                        onClick={() => push(referer)}
                    >
                        {intl.formatMessage({ id: 'buttons.back' })}
                    </ButtonCinestar>
                </div>
                <div className="w-50 d-flex justify-content-center align-items-center">
                    <OrderStepCircle active={true} text={'Zakoupení dárkových poukázek'} />
                </div>

                <div className="w-25"></div>
            </div>

            <EmptyBasket />

            <div className={'order-summary-page--content position-relative d-flex flex-column mx-auto'}>
                {basket?.items_vouchers?.map((item, idx) => (
                    <GoodsWidthAmount
                        key={idx}
                        leftTitle={'Poukaz'}
                        description={item.name}
                        price={item.price}
                        currency={item.currency}
                        amount={item.amount}
                        addOne={() => {
                            if (item.amount >= 20) {
                                return
                            }
                            gtmAddGiftVoucher(item.voucherid, item.name, item.price)
                            setVoucher(item.amount + 1, item.voucherid)
                        }}
                        removeOne={() => {
                            gtmRemoveGiftVoucher(item.voucherid, item.name, item.price)
                            setVoucher(item.amount - 1, item.voucherid)
                        }}
                    />
                ))}

                <AddVoucher onClick={() => push(referer)} />

                {!(isAuthorized || userInfo) && <ContactInfo setUserInfo={setUserInfo} />}

                <PaymentMethod
                    selectedPayment={basket?.selected_payment}
                    setPaymentMethod={(payment) => setPayment(payment)}
                    note={basket?.note}
                    allowedPayments={basket?.allowed_payments}
                    goPayVariant={goPayVariant}
                    setGoPayVariant={setGoPayVariant}
                />
            </div>
            <>
                {!(isAuthorized || userInfo) && (
                    <InfoWindow
                        color={'white'}
                        description={intl.formatMessage({ id: 'windows.notification.needUserInfo' })}
                    />
                )}
                <FormCustomBenefitPayment />
                <Basket
                    loading={!(isAuthorized || userInfo)}
                    show
                    variant={BASKET_TYPES.PAYMENT}
                    onPayment={() => paymentStart({ user: isAuthorized ? userAuthInfo : userInfo, basket })}
                />
                <img
                    src={'images/cinestar/astronaut-thumbs-up.png'}
                    alt={'astronaut-thumbs-up'}
                    className={'astronaut-animate w-50 h-auto mx-auto'}
                />
            </>
        </Container>
    )
}

export default hocBuyTicketVoucher(BuyTicketVoucher)
